let pending = false;

function setStatus(message: string, outcome: 'pending' | 'success' | 'error') {
    if (typeof document === 'undefined') {
        return;
    }

    const status = document.getElementById('comment-response');

    if (status) {
        status.textContent = message;
        status.dataset.outcome = outcome;
    }
}

function notify(message: string, outcome: 'success' | 'error') {
    setStatus(message, outcome);

    if (typeof toastr === 'undefined') {
        return;
    }

    Object.assign(toastr.options, {
        closeButton: true,
        timeOut: 10000,
        preventDuplicates: true,
        progressBar: true,
        escapeHtml: true
    });
    toastr[outcome](message);
}

function submitComment() {
    if (pending || !$('#commentForm').valid()) {
        return;
    }

    const url = $('#commentForm').attr('action');

    if (!url) {
        return;
    }

    const requestVerificationToken = $('[name=__RequestVerificationToken]').val();
    const hCaptchaResponse = $('[name=h-captcha-response]').val();
    const idPost = $('#PostModel_IdPost').val();
    const selectedCommentId = $('#SelectedCommentId').val();
    const fullNameValue = $('#CommentBindingModel_CommenterFullName').val();
    const emailValue = $('#CommentBindingModel_CommenterEmail').val();
    const webAddressValue = $('#CommentBindingModel_CommenterWebAddress').val();
    const bodyValue = $('#CommentBindingModel_CommenterCommentBody').val();

    const formData = new FormData();
    formData.append('__RequestVerificationToken', String(requestVerificationToken ?? ''));
    formData.append('h-captcha-response', String(hCaptchaResponse ?? ''));
    formData.append('PostModel.IdPost', String(idPost ?? ''));
    formData.append('SelectedCommentId', String(selectedCommentId ?? ''));
    formData.append('CommentBindingModel.CommenterFullName', String(fullNameValue ?? ''));
    formData.append('CommentBindingModel.CommenterEmail', String(emailValue ?? ''));
    formData.append('CommentBindingModel.CommenterWebAddress', String(webAddressValue ?? ''));
    formData.append('CommentBindingModel.CommenterCommentBody', String(bodyValue ?? ''));

    pending = true;
    $('#submitButton').prop('disabled', true);
    $('#submitButton').attr('aria-busy', 'true');
    setStatus('Sending message…', 'pending');
    $.ajax({
        type: 'POST',
        url,
        data: formData,
        processData: false,
        contentType: false,
        success: () =>
            notify(
                'Congratulations. Your comment message was saved successfully. Your comment will be published as soon as it is reviewed.',
                'success'
            ),
        error: () =>
            notify(
                'Unfortunately, your comment message was not saved successfully. Please submit your comment again later.',
                'error'
            ),
        complete: () => {
            pending = false;
            $('#submitButton').attr('aria-busy', 'false');
            const challenge = $('[name=h-captcha-response]').val();
            $('#submitButton').prop('disabled', typeof challenge !== 'string' || !challenge.trim());
        }
    });
}

Object.assign(globalThis, { submitComment });

if (typeof document !== 'undefined') {
    document.addEventListener('click', (event) => {
        const control =
            event.target instanceof Element
                ? event.target.closest<HTMLButtonElement | HTMLInputElement>('[data-submit-comment]')
                : null;

        if (control && !control.disabled) {
            event.preventDefault();
            submitComment();
        }
    });
}
